import clsx from 'clsx';
import { RealEstate, TtDetails } from '../../generated/graphql';
import { useTtDetails } from '../../TtDetails';
import { RealEstatePropertyTableContainer, RealEstatePropertyTableContainerProps } from './RealEstatesTableContainer';
import { RealEstateSumTableItem } from './RealEstateSumTableItem';

interface PersonalFinancialStatementRealEstatesTableProps extends Pick<RealEstatePropertyTableContainerProps, 'tableTitleClassName'> {
  title: string;
  householdID: string;
  onItemClicked?: (a: { realEstate: RealEstate }) => void;
  realEstatesSubset: keyof Pick<TtDetails['assetSummary'], 'personalRealEstate' | 'investmentRealEstate'>;
}

export function PersonalFinancialStatementRealEstatesTable({
  title,
  householdID,
  onItemClicked,
  realEstatesSubset,
  tableTitleClassName,
}: PersonalFinancialStatementRealEstatesTableProps) {
  const { ttDetails, ttDetailsQuery } = useTtDetails({ householdID, includeAssetSummary: true });

  return (
    <RealEstatePropertyTableContainer
      title={title}
      isLoading={ttDetailsQuery.isLoading}
      tableRowsContainerClassName="mt-[2px]"
      className="mb-4 md:mb-[47px] last:mb-6"
      tableTitleClassName={clsx(tableTitleClassName, 'sticky top-[56px] z-[1] bg-darkMode-gray-background')}
      realEstatePropertyArray={Array.from(ttDetails?.assetSummary[realEstatesSubset] || [])}
    >
      {({ realEstate }) => (
        <RealEstateSumTableItem
          realEstate={realEstate}
          onItemClicked={onItemClicked}
          className="focus:shadow-classic"
        />
      )}
    </RealEstatePropertyTableContainer>
  );
}
